import { PMLineChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import {
  getCompletedItemsDataAndCategories,
  TIMEFRAME_OPTIONS,
} from "../../../utils/getCompletedItemsByTimeframe";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCompletedProjectsLineChartCard(ctx: DashboardCardContext) {
  const { view, language, projectNamePlural, getCardCopy } = ctx;

  const completedProjectsLineChartComponent = view.addComponent({
    component: PMLineChartCard,
    layoutProps: {
      componentId: "completedProjectsLineChartComponent",
      title: "",
      description: "",
      labels: ["lineChart", "chart", "completedProjectsLineChartComponent"],
    },
  });

  completedProjectsLineChartComponent.mapLayoutProps(() => {
    return {
      componentId: "completedProjectsLineChartComponent",
      labels: ["lineChart", "chart", "completedProjectsLineChartComponent"],
      title: getCardCopy(language, "completedProjectsOverTime").title,
      description: getCardCopy(language, "completedProjectsOverTime")
        .description,
    };
  });

  completedProjectsLineChartComponent.mapState((appState) => {
    const completedProjectsOverReportingCycle =
      appState?.dashboard?._calculated?.completedProjectsOverReportingCycle;
    const language = appState?.language;
    const { data, categories } = getCompletedItemsDataAndCategories(
      completedProjectsOverReportingCycle
    );
    return {
      title: getCardCopy(language, "completedProjectsOverTime").title,
      timespans: TIMEFRAME_OPTIONS,
      data,
      categories,
      xLabel: getLocalizedMessage(language, "time") || "Time",
      yLabel: `${getLocalizedMessage(language, "completedPlural")} ${
        projectNamePlural
      }`,
    };
  });

  completedProjectsLineChartComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
